import { RouterProvider } from 'react-router-dom';

// routing
import router from 'routes';

// project imports
import Locales from 'ui-component/Locales';
import NavigationScroll from 'layout/NavigationScroll';
import RTLLayout from 'ui-component/RTLLayout';
import Snackbar from 'ui-component/extended/Snackbar';
import Notistack from 'ui-component/third-party/Notistack';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

import ThemeCustomization from 'themes';

// auth provider
import { JWTProvider as AuthProvider } from 'contexts/JWTContext';
import { LocalizationLanguageProvider } from 'contexts/LocalizationContext';
import FaviconWithBadge from 'layout/FaviconWithBadge';
import { SignalRProvider } from 'contexts/SignalRContext';
import { LocalizationProvider } from '@mui/x-date-pickers';
// import { FirebaseProvider as AuthProvider } from 'contexts/FirebaseContext';
// import { Auth0Provider as AuthProvider } from 'contexts/Auth0Context';
// import { AWSCognitoProvider as AuthProvider } from 'contexts/AWSCognitoContext';
// import { SupabseProvider as AuthProvider } from 'contexts/SupabaseContext';

// ==============================|| APP ||============================== //

export default function App() {
  return (
    <ThemeCustomization>
      <RTLLayout>
        <Locales>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <LocalizationLanguageProvider>
              <NavigationScroll>
                <Notistack>
                  <AuthProvider>
                    <SignalRProvider>
                      <RouterProvider router={router} />
                      <Snackbar />

                      <FaviconWithBadge />
                    </SignalRProvider>
                  </AuthProvider>
                </Notistack>
              </NavigationScroll>
            </LocalizationLanguageProvider>
          </LocalizationProvider>
        </Locales>
      </RTLLayout>
    </ThemeCustomization>
  );
}
